import { Link } from "react-router-dom";
import Reveal from "./Reveal";
import { ArrowRight } from "lucide-react";

const STEPS = [
  { n: "01", t: "Tell us the box", d: "Sizes, quantity, print — a photo of a sketch is enough." },
  { n: "02", t: "We quote fast", d: "A clear price per box, no listed rates, no surprises." },
  { n: "03", t: "Sample & approve", d: "We fold a sample to your exact die before the run." },
  { n: "04", t: "Folded & delivered", d: "Produced in our Kampala workshop, delivered to your door." },
];

const MATERIALS = ["KRAFT 150–440 GSM", "GREYBOARD RIGID", "E-FLUTE", "B-FLUTE", "FOOD-GRADE", "WHITE-LINED", "FULL-COLOUR PRINT", "FOIL STAMP"];

export default function Craft() {
  return (
    <section id="craft" className="relative kraft-card text-coal py-24 sm:py-32" data-testid="craft-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-pine mb-4">
            03 — The Craft
          </p>
          <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
            <h2 className="font-display font-semibold tracking-tight text-3xl sm:text-5xl leading-[1.02] max-w-2xl">
              From brief to doorstep,<br />in four folds.
            </h2>
            <Link
              to="/quote"
              data-testid="craft-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-forest text-kraft font-semibold px-7 h-12 hover:bg-pine transition-colors"
            >
              Start a quote
              <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08} className="h-full">
              <div className="h-full rounded-2xl border border-coal/10 bg-kraft/60 p-6 hover:bg-white/50 transition-colors clip-tag">
                <p className="font-mono text-xs text-gold font-semibold mb-6">{s.n}</p>
                <h3 className="font-display font-semibold text-xl mb-2">{s.t}</h3>
                <p className="text-sm text-coal/65 leading-relaxed">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 flex flex-wrap gap-2.5">
            {MATERIALS.map((m) => (
              <span
                key={m}
                className="font-mono text-[10px] tracking-[0.2em] uppercase border border-coal/15 rounded-full px-4 py-2 text-coal/70 hover:border-pine hover:text-pine transition-colors cursor-default"
              >
                {m}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
